import PCCLoadingComponent from "@/components/pcc/PCCLoadingComponent";
import { PCCEvaluationResult } from "@/components/pcc/PCCEvaluationResult";
import { useEvaluateCompliance } from "@/hooks/compliance/compliance.hook";
import { useEffect } from "react";

const ApplyForPCCPage = () => {
    const { isPending: isEvaluatingCompliance, data: complianceEvaluation, mutate: evaluateCompliance } = useEvaluateCompliance();

    useEffect(() => {
        evaluateCompliance();
    }, [evaluateCompliance]);


    return (
        <div className="w-full flex flex-col min-h-screen-without-navbar mt-6">
            {isEvaluatingCompliance ? <PCCLoadingComponent /> : <PCCEvaluationResult complianceEvaluationData={complianceEvaluation} />}
        </div>
    )
}

export default ApplyForPCCPage; 